// extracted by mini-css-extract-plugin
export default {"pageLayout":"ArchivedJobProspects-module__pageLayout___DZn4w"};